import { render, staticRenderFns } from "./editRelationModal.vue?vue&type=template&id=543f0a4a&scoped=true&"
import script from "./editRelationModal.vue?vue&type=script&lang=js&"
export * from "./editRelationModal.vue?vue&type=script&lang=js&"
import style0 from "./editRelationModal.vue?vue&type=style&index=0&id=543f0a4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543f0a4a",
  null
  
)

export default component.exports